export default __webpack_public_path__ + "ea2c095aebea47eba7296d566094edde.svg";